import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, cloneElement, isValidElement, useCallback, useMemo, useRef } from 'react';
import { Label } from '../Label';
import { CheckboxIndicator } from './components/CheckboxIndicator';
export const CheckboxValue = {
    checked: 'checked',
    unchecked: 'unchecked'
};
const Checkbox = (props) => {
    const { children, onChange, checked = false, ariaLabelledBy } = props;
    const checkboxRef = useRef(null);
    const onClickHandler = useCallback(() => { var _a; return onChange === null || onChange === void 0 ? void 0 : onChange(((_a = checkboxRef.current) === null || _a === void 0 ? void 0 : _a.value) === CheckboxValue.unchecked); }, [onChange, checkboxRef]);
    const _indicator = useMemo(() => {
        return Children.map(children, child => {
            if (isValidElement(child) && child.type === CheckboxIndicator) {
                return cloneElement(child, { checked, ...child.props });
            }
        });
    }, [children, checked]);
    const _label = useMemo(() => {
        return Children.map(children, child => {
            if (isValidElement(child) && child.type === Label) {
                return cloneElement(child, {
                    ...child.props,
                    onClick: onClickHandler
                });
            }
        });
    }, [children, onClickHandler]);
    return (_jsxs(_Fragment, { children: [_jsx("button", { ref: checkboxRef, type: "button", role: "checkbox", "aria-checked": checked, "aria-labelledby": ariaLabelledBy, value: checked ? CheckboxValue.checked : CheckboxValue.unchecked, className: props.className, onClick: onClickHandler, style: props.style, "data-testid": props['data-testid'], name: props.name, children: _indicator }), _label] }));
};
export { Checkbox };
//# sourceMappingURL=Checkbox.js.map